import { render, staticRenderFns } from "./UsuarioPermissoesTree.vue?vue&type=template&id=ed90ffb4&scoped=true&"
import script from "./UsuarioPermissoesTree.vue?vue&type=script&lang=js&"
export * from "./UsuarioPermissoesTree.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioPermissoesTree.vue?vue&type=style&index=0&id=ed90ffb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed90ffb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCheckbox,VTreeview})
